var map = {
	"./": [
		94881,
		881
	],
	"./index": [
		94881,
		881
	],
	"./index.ts": [
		94881,
		881
	],
	"./refunds": [
		93934,
		934
	],
	"./refunds.tsx": [
		93934,
		934
	],
	"./shipping": [
		86292,
		292
	],
	"./shipping.tsx": [
		86292,
		292
	],
	"./tos": [
		32405,
		642
	],
	"./tos.tsx": [
		32405,
		642
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 88455;
module.exports = webpackAsyncContext;